import React from 'react';


export default function LoadingOverlay({
  isVisible = false,
  message = 'Cargando...',
  progress = null, // 0-100 for progress bar, null for spinner only
  fullScreen = false,
}) {
  if (!isVisible) return null;

  return (
    <div
      className={[
        'flex items-center justify-center z-overlay',
        fullScreen
          ? 'fixed inset-0' :'absolute inset-0 rounded-lg',
      ]?.join(' ')}
      style={{ background: 'rgba(28,25,23,0.6)' }}
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div
        className="bg-card rounded-xl px-8 py-6 flex flex-col items-center gap-4 min-w-[200px]"
        style={{ boxShadow: '0 20px 40px -8px rgba(28,25,23,0.16)' }}
      >
        {/* Spinner */}
        <div
          className="w-10 h-10 rounded-full border-4 border-muted"
          style={{
            borderTopColor: 'var(--color-primary)',
            animation: 'spin 700ms linear infinite',
          }}
          aria-hidden="true"
        />

        {/* Message */}
        <p className="text-sm font-caption font-medium text-foreground text-center">
          {message}
        </p>

        {/* Progress bar */}
        {progress !== null && (
          <div className="w-full">
            <div className="flex justify-between mb-1">
              <span className="text-xs font-caption text-muted-foreground">Progreso</span>
              <span className="text-xs font-caption font-medium text-foreground">
                {Math.round(progress)}%
              </span>
            </div>
            <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-[250ms] ease-out"
                style={{
                  width: `${Math.min(100, Math.max(0, progress))}%`,
                  background: 'var(--color-primary)',
                }}
                role="progressbar"
                aria-valuenow={progress}
                aria-valuemin={0}
                aria-valuemax={100}
              />
            </div>
          </div>
        )}
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}